import React from "react";
import { t } from "@lingui/macro";
import { i18n, formatItemOnfieldType } from "idc-ui-react";

// Properties for filter props (sort)
function setColumnFilterProps(fieldName, endpointDefinition) {
  return {
    filterName: fieldName,
    filterHandlerType: "ENDPOINT_FILTER",
    filterHandler: endpointDefinition
  };
}

// Properties for Context menu
function setColumnContextMenuProps(fieldType, endpointDefinition) {
  switch (fieldType) {
    case "Date":
      return {
        filterType: "DATES",
        filterHandlerType: "ENDPOINT_FILTER",
        filterHandler: endpointDefinition
      };
    default:
      return null;
  }
}

// Properties for filter clear button
function setColumnClearProps(endpointDefinition) {
  return {
    filterHandlerType: "ENDPOINT_FILTER",
    filterHandler: endpointDefinition
  };
}

// Properties for clear filter button
function hasFilterItems(filterItems) {
  if (!filterItems) return false;
  const params = [];
  filterItems.forEach(p => {
    let val = p.split("=");
    // Page number and page size and sort choises should not activate clear filter button
    if (
      val[0] !== "pageno" &&
      val[0] !== "pagesize" &&
      val[0] !== "sortby" &&
      val[0] !== "sortorder" &&
      val[1]
    )
      params.push(val[0]);
  });
  return params.length > 0;
}

// get isSortedDescending from user selection first and endpoint next
function setIsSortedDescending(isSortedDescending, params) {
  if (!params || params.length === 0)
    return isSortedDescending ? isSortedDescending : false;
  const sortorder = params.filter(p => p.split("=")[0] === "sortorder");
  if (sortorder.length > 0) return sortorder[0].split("=")[1] === "desc";
  return isSortedDescending ? isSortedDescending : false;
}

function setOnRender(fieldType, fieldName) {
  return item => (
    <span>{formatItemOnfieldType(item[fieldName], fieldType)}</span>
  );
}

export function reportColumns(params, columnDefinition, endpointDefinition) {
  const columnClearProps = setColumnClearProps(endpointDefinition);
  const baseColumns = columnDefinition
    .map(c => {
      const columnFilterProps = setColumnFilterProps(
        c.fieldName,
        endpointDefinition
      );
      const columnContextMenuProps = setColumnContextMenuProps(
        c.fieldType,
        endpointDefinition
      );
      const isSortedDescending = setIsSortedDescending(
        c.sortedDescending,
        params
      );
      const onRender = setOnRender(c.fieldType, c.fieldName);
      return {
        key: c.name,
        name: c.name,
        fieldName: c.fieldName,
        minWidth: c.minWidth ? c.minWidth : 50,
        maxWidth: c.maxWidth ? c.maxWidth : 300,
        isResizable: c.resizable ? c.resizable : false,
        isMultiline: c.multiline ? c.multiline : false,
        isSorted: c.sorted ? c.sorted : false,
        isSortedDescending: isSortedDescending,
        isCollapsible: c.collapsible ? c.collapsible : false,
        applyColumnFilter: c.applyColumnFilter ? c.applyColumnFilter : false,
        columnFilterProps: c.applyColumnFilter ? columnFilterProps : {},
        applyColumnClick: c.applyColumnClick ? c.applyColumnClick : false,
        applyColumnDisabled: c.applyColumnDisabled
          ? c.applyColumnDisabled
          : false,
        applyColumnContextMenu: c.applyColumnContextMenu
          ? c.applyColumnContextMenu
          : false,
        columnContextMenuProps:
          c.applyColumnContextMenu && columnContextMenuProps
            ? columnContextMenuProps
            : {},
        onRender: onRender
      };
    })
    .sort((a, b) => {
      return a.columnOrder - b.columnOrder;
    });

  const clearFilterColumn = {
    key: "clearfilter",
    name: " " + i18n._(t`Clear filter`),
    fieldName: "fieldName",
    isResizable: false,
    minWidth: 100,
    maxWidth: 100,
    iconName: "ClearFilter",
    applyColumnClick: true,
    applyPagingClearFilter: true,
    columnClearProps: columnClearProps
  };
  return hasFilterItems(params)
    ? [...baseColumns, clearFilterColumn]
    : [...baseColumns];
}
